import useCustomWidget from '../CustomWidget/useCustomWidget';
import { GetMetricsMetadata } from '../../custom-report.serivce';
import { isEqualAllTeams } from '../../Filters/TeamsDropdown';
import get from 'lodash/get';
import { useSelector } from 'react-redux';
import { teamsSelector } from 'state/selectors/teams';
import useSettingsService from 'components/hooks/useSettingsService';
import { getGoalsSummaryTooltipTitle } from '../../Tooltip';
import { GRAPH_TYPES } from '../consts/graphTypes';
import { FORMATTERS } from '../../consts';
import moment from 'moment';
import _ from 'lodash';
import { organizationSelector } from 'state/selectors/organization';

// this is a temporary fix until its handled in the backend
const getFilteredWidgetMetrics = (metricsData, team, organization) => {
  if (!metricsData?.length) {
    return metricsData;
  }

  try {
    const minDate = moment.max([
      moment(team.created_at),
      moment(organization.created_at)
    ]);
    // deepclone
    const newData = JSON.parse(JSON.stringify(metricsData));
    const data = _.get(newData, '[0].data', []);
    const filteredData = data.map(item => {
      if (minDate.isAfter(moment(item.before))) {
        return { after: item.after, before: item.before };
      }
      return item;
    });
    newData[0].data = filteredData;
    return newData;
  } catch (exp) {
    return metricsData;
  }
};

const useGoalsCustomWidget = ({
  graph,
  filters,
  widgetMetrics: widgetMetricsProp
}) => {
  const currentTeams = useSelector(teamsSelector);
  const organization = useSelector(organizationSelector);
  const { getSettingOrDefinitionValue } = useSettingsService();

  const defaultTeam = !isEqualAllTeams(filters.globallySelectedTeams)
    ? get(filters.globallySelectedTeams, '[0]')
    : get(currentTeams, [0], []);

  const metadata =
    GetMetricsMetadata(graph.id, defaultTeam, getSettingOrDefinitionValue) ||
    {};

  const {
    goalsValues,
    didNotMeetGoalTooltipDescription = '',
    subtitle,
    axisTitle
  } = metadata;

  const widgetMetrics = {
    ...widgetMetricsProp,
    data: getFilteredWidgetMetrics(
      widgetMetricsProp?.data,
      defaultTeam,
      organization
    )
  };

  const defaultCustomWidgetProps = useCustomWidget({
    graph,
    filters,
    widgetMetrics
  });

  const { headerProps, graphProps } = defaultCustomWidgetProps;

  const goalsAvgPercent =
    goalsValues && goalsValues(widgetMetrics.data?.[0]?.data ?? [])?.percent;

  const boldedValueTooltipTitle = getGoalsSummaryTooltipTitle({
    metrics: widgetMetrics.data,
    metricName: widgetMetrics.name,
    dateRange: filters.selectedTimeRanges,
    didNotMeetGoalTooltipDescription
  });

  return {
    ...defaultCustomWidgetProps,
    headerProps: {
      ...headerProps,
      formattedAverage: graph.unitType
        ? FORMATTERS[graph.unitType]?.avgFormatter(goalsAvgPercent) ?? ''
        : '',
      boldedValueTooltipTitle,
      subtitle,
      headerProps: null
    },
    graphProps: {
      ...graphProps,
      [GRAPH_TYPES.STACKED]: { ...graphProps[GRAPH_TYPES.STACKED], axisTitle }
    },
    boldedValueTooltipTitle
  };
};

export default useGoalsCustomWidget;
